'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.siteFooter = twentyninetimes.siteFooter || function () {

	function init() {
		let footer_accordions = document.querySelectorAll('.js-footer-accordion');

		if ( footer_accordions ) {
      footer_accordions.forEach(accordion => {
        footerAccordion(accordion);
      });
		}
	}

  function footerAccordion(accordion) {
    var trigger = accordion.querySelector('.footer-column__header');

    if (!trigger) return;

    trigger.addEventListener('click', function(e) {
      e.stopPropagation;

      var content = accordion.querySelector('.footer-column__content');

      if ( !accordion.classList.contains('open') ) {
        content.style.height = 'auto';
        var height = content.clientHeight;
        content.style.height = '0px';

        setTimeout(function () {
          accordion.classList.add('open');
          content.style.height = height + 'px';;

          setTimeout(function () {
            if ( accordion.classList.contains('open') ) {
              content.style.height = 'auto';
            }
          }, 400);
        }, 10);
      } else {
        var height = content.clientHeight;
        content.style.height = height + 'px';

        setTimeout(function () {
          content.style.height = '0px';
          accordion.classList.remove('open');			
        }, 10);
      }
    });
  }

  return {
    init : init
  };

}();